import { Directive, Input, ElementRef, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[layoutGap]',
    standalone: false
})
export class LayoutGapDirective implements OnChanges {
    @Input() layoutGap: string | number = '';

    private readonly _directiveName = 'layoutGap';
    private readonly baseUnit = 8;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['layoutGap']) {
            this.updateGap();
        }
    }

    private updateGap(): void {
        const rawValue = Number(this.layoutGap);
        if (isNaN(rawValue) || rawValue < 0) {
            console.warn(`[${this._directiveName}] Invalid gap value "${this.layoutGap}". Expected positive number.`);
            return;
        }
        const px = rawValue * this.baseUnit;
        this.renderer.setStyle(this.el.nativeElement, 'gap', `${px}px`);
    }
}
